const engRusKeyboard = {
  'q': 'й',
  'w': 'ц',
  'e': 'у',
  'r': 'к',
  't': 'е',
  'y': 'н',
  'u': 'г',
  'i': 'ш',
  'o': 'щ',
  'p': 'з',
  '[': 'х',
  '{': 'Х',
  ']': 'ъ',
  '}': 'Ъ',
  '|': '/',
  '`': 'ё',
  '~': 'Ё',
  'a': 'ф',
  's': 'ы',
  'd': 'в',
  'f': 'а',
  'g': 'п',
  'h': 'р',
  'j': 'о',
  'k': 'л',
  'l': 'д',
  ';': 'ж',
  ':': 'Ж',
  '\'': 'Э',
  'z': 'я',
  'x': 'ч',
  'c': 'с',
  'v': 'м',
  'b': 'и',
  'n': 'т',
  'm': 'ь',
  ',': 'б',
  '<': 'Б',
  '.': 'ю',
  '>': 'Ю',
  '/': '.',
  '?': ',',
  '@': '\'',
  '#': '№',
  '$': ';',
  '^': ':',
  '&': '?'
}

const word = {
  escapeRegExp (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&')
  },
  getRegExp: function (pattern, flags) {
    return new RegExp(this.escapeRegExp(pattern), flags)
  },
  engToRus: function (word = '') {
    let str = ''
    let letter = ''
    for (let i = 0; i < word.length; i++) {
      letter = word.charAt(i)
      str += engRusKeyboard[letter] || letter
    }
    return str
  }
}

export default word
